export default "__VITE_ASSET__4852fb76__"